import {Component, Input, OnInit} from '@angular/core';
import {QuestionResult} from '../../../data/models/result/question-result';
import {QUESTION_TYPES} from '../../../../constants/questionTypes';

@Component({
  selector: 'app-question-result',
  templateUrl: './question-result.component.html',
  styleUrls: ['./question-result.component.css']
})
export class QuestionResultComponent implements OnInit {

  readonly QUESTION_TYPES = QUESTION_TYPES;

  @Input() testId!: number;
  @Input() testResultId!: number;
  @Input() testType!: string;
  @Input() index!: number;
  @Input() questionResult!: QuestionResult;
  @Input() readonly = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
